import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { ForwardIcon } from 'foundations-assets/icons/components/ForwardIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuggestedPromptRow = ({
  label,
  text,
  onSelect
}) => {
  const [isHighlighted, setIsHighlighted] = useState(false);
  return /*#__PURE__*/_jsx(Clickable, {
    paddingBlock: "100",
    paddingInline: "100",
    onClick: () => onSelect(text),
    onMouseEnter: () => setIsHighlighted(true),
    onMouseLeave: () => setIsHighlighted(false),
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      borderRadius: "200",
      backgroundColor: isHighlighted ? 'fill-surface-default-hover' : undefined,
      children: [/*#__PURE__*/_jsx(ForwardIcon, {
        size: "100",
        color: "fill-brand-default"
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        textAlign: "start",
        children: label
      })]
    })
  });
};
export const SuggestedLearningPrompts = ({
  onSelect
}) => /*#__PURE__*/_jsxs(View, {
  borderWidth: "100",
  borderStyle: "solid",
  borderColor: "border-core-subtle",
  borderRadius: "400",
  backgroundColor: "fill-surface-default",
  paddingBlock: "400",
  paddingInline: "400",
  children: [/*#__PURE__*/_jsx(View, {
    paddingBlockEnd: "300",
    children: /*#__PURE__*/_jsx(Text, {
      as: "h4",
      typography: "heading-50",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.chat.suggestedPrompts.title"
      })
    })
  }), /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    children: [/*#__PURE__*/_jsx(SuggestedPromptRow, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.chat.suggestedPrompts.doSomethingInHubspot"
      }),
      text: I18n.text('academy-ai-assistant.chat.suggestedPrompts.doSomethingInHubspot'),
      onSelect: onSelect
    }), /*#__PURE__*/_jsx(SuggestedPromptRow, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.chat.suggestedPrompts.growSkillsForRole"
      }),
      text: I18n.text('academy-ai-assistant.chat.suggestedPrompts.growSkillsForRole'),
      onSelect: onSelect
    }), /*#__PURE__*/_jsx(SuggestedPromptRow, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.chat.suggestedPrompts.getCertified"
      }),
      text: I18n.text('academy-ai-assistant.chat.suggestedPrompts.getCertified'),
      onSelect: onSelect
    }), /*#__PURE__*/_jsx(SuggestedPromptRow, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.chat.suggestedPrompts.dontKnowWhereToStart"
      }),
      text: I18n.text('academy-ai-assistant.chat.suggestedPrompts.dontKnowWhereToStart'),
      onSelect: onSelect
    })]
  })]
});